'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var createGetFormAsyncErrors = function createGetFormAsyncErrors(_ref) {
  var getIn = _ref.getIn;
  return function (form) {
    var getFormState = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : function (state) {
      return getIn(state, 'form');
    };
    return function (state) {
      return getIn(getFormState(state), form + '.asyncErrors');
    };
  };
};

exports.default = createGetFormAsyncErrors;


//////////////////
// WEBPACK FOOTER
// ./~/redux-form/lib/selectors/getFormAsyncErrors.js
// module id = 567
// module chunks = 0